import React from "react";
import { observer } from "mobx-react";
import { Group, Text, ActionIcon, Anchor } from "@mantine/core";
import { IconProps } from "@tabler/icons-react";
import {
  showBtcAmount,
  convertSatsToFiatString,
} from "../../helpers/conversions";
import { Cubby } from "../../stores/Cubby";
import TopRightInfoCircle from "./topRightInfoCircle";
import InfoCircle from "./infoCircle";
import { TextWithInfo } from "../modals/textWithInfo";
import { useMediaQuery } from "@mantine/hooks";
import { InfoLinkToDocsSlug } from "../modals/infoLinkToDocsSlug";

interface ShowBalanceRowProps {
  icon: React.ComponentType<IconProps>;
  label: string;
  amount: number;
  cubby: Cubby;
  articleSlug?: string;
}

const ShowBalanceRow: React.FC<ShowBalanceRowProps> = observer(
  ({ icon: Icon, label, amount, cubby, articleSlug }) => {
    const isMobile = useMediaQuery("(max-width: 768px)");

    return (
      <tr>
        <td>
          <Group gap="xs">
            <Icon size="1.4rem" />
            <InfoLinkToDocsSlug
              textSize="lg"
              text={label}
              articleSlug={articleSlug}
              cubby={cubby}
            />
          </Group>
        </td>
        <td>{showBtcAmount(amount, cubby)}</td>
        <td>{convertSatsToFiatString(amount, cubby, isMobile)}</td>
      </tr>
    );
  }
);

export default ShowBalanceRow;
